import React from "react";
import { GQLOption } from "../../../schemas/schema";

interface IIsedEvaluationProps {
  indicators: GQLOption[]
  checkedIndicators: (indicators: GQLOption[]) => GQLOption[]
  renderedIndicators: JSX.Element
}

export const InnerModalLegacyIndicators = (
  {
    indicators,
    checkedIndicators,
    renderedIndicators
  }: IIsedEvaluationProps
) => {
  return <>
        { indicators.length > 0 && (
            <>
                <span className="nselected-category ">
                  { checkedIndicators(indicators).length } out of { indicators.length } selected
                </span>
                { renderedIndicators }
            </>
        )}
    </>;
};
